<template>
  <div class="snow">
    <div class="py-10">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Digital-Schnellcheck
            </div>
            <div
              class="text-uppercase display-1 pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Digital-Schnellcheck
            </div>

            <v-divider
              style="border-color: #7d9b38; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>

            <p class="title font-weight-light pt-6">
              Zwei Schritte mit je fünf kurzen Fragen - und Sie wissen in
              wenigen Minuten, wie digital Ihre Organisation ist. Vergleichen
              Sie sich in unserem Digital-Schnellcheck mit ähnlichen
              Organisationen oder mit unserer gesamten Stichprobe.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container class="py-4" id="content">
      <v-stepper v-model="stepper" vertical class="mb-12 elevation-0">
        <v-stepper-step :complete="stepper > 1" step="1">
          Wie ist Ihre Organisation digital aufgestellt?
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-container fluid>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-subheader class="black--text"
                  >Wir haben ein klares Verständnis davon, wie IT zu unserem
                  Erfolg beitragen kann.</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="6">
                <v-slider
                  v-model="item1"
                  :max="4"
                  :tick-labels="ticksLabels"
                  color="#7D9B38"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader class="black--text"
                  >Wir haben die erforderliche Kompetenz in der Organisation, um
                  unsere IT managen zu können.</v-subheader
                >
              </v-col>

              <v-col cols="12" sm="6">
                <v-slider
                  v-model="item2"
                  :max="4"
                  :tick-labels="ticksLabels"
                  color="#7D9B38"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader class="black--text"
                  >Unsere Organisation ist immer mit neuesten Technologien
                  ausgestattet.</v-subheader
                >
              </v-col>

              <v-col cols="12" sm="6">
                <v-slider
                  v-model="item3"
                  :max="4"
                  :tick-labels="ticksLabels"
                  color="#7D9B38"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader class="black--text"
                  >Um neue IT-Anwendungen zu nutzen, haben wir das nötige
                  Wissen.</v-subheader
                >
              </v-col>

              <v-col cols="12" sm="6">
                <v-slider
                  v-model="item4"
                  :max="4"
                  :tick-labels="ticksLabels"
                  color="#7D9B38"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader class="black--text"
                  >Um neue IT-Anwendungen zu nutzen, haben wir die nötigen
                  Ressourcen.</v-subheader
                >
              </v-col>

              <v-col cols="12" sm="6">
                <v-slider
                  v-model="item5"
                  :max="4"
                  :tick-labels="ticksLabels"
                  color="#7D9B38"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-col>
            </v-row>
          </v-container>
          <v-btn rounded color="accent" depressed @click="stepper = 2"
            >Zu Schritt 2</v-btn
          >
        </v-stepper-content>

        <v-stepper-step :complete="stepper > 2" step="2"
          >Charakteristika Ihrer Organisation</v-stepper-step
        >

        <v-stepper-content step="2">
          <v-container fluid>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-subheader
                  class="black--text"
                  v-text="
                    'In welchem Bundesland ist Ihre Organisation registriert?'
                  "
                ></v-subheader>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="state"
                  :items="Object.keys(levels.state_levels)"
                  :menu-props="{ maxHeight: '400' }"
                  label="Bundesland"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader
                  class="black--text"
                  v-text="'In welchem Bereich sind Sie hauptsächlich tätig?'"
                ></v-subheader>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="sector"
                  :items="Object.keys(levels.sector_levels)"
                  :menu-props="{ maxHeight: '400' }"
                  label="Bereich"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader
                  class="black--text"
                  v-text="'Wie alt ist Ihre Organisation?'"
                ></v-subheader>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="age"
                  :items="Object.keys(levels.age_levels)"
                  :menu-props="{ maxHeight: '400' }"
                  label="Alter in Jahren"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-subheader
                  class="black--text"
                  v-text="
                    'Wie groß ist das jährliche Budget Ihrer Organisation?'
                  "
                ></v-subheader>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="budget"
                  :items="Object.keys(levels.budget_levels)"
                  :menu-props="{ maxHeight: '400' }"
                  label="Jahresbudget in Euro"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-row>
                  <v-subheader
                    class="black--text"
                    v-text="'Wie finanzieren Sie Ihre Organisation?'"
                  ></v-subheader>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on"
                        >mdi-information</v-icon
                      >
                    </template>
                    <span>
                      <b>Erklärung der Kategorien</b>: <br />
                      NPO Klassisch: Finanzierung durch Spenden und
                      Mitgliederbeiträge <br />

                      NPO Hybrid: Finanzierung durch Spenden, Mitgliederbeiträge
                      sowie anteilig durch Dienstleistungen
                      <br />

                      NPO Social Business: Mehrheitliche Finanzierung durch
                      Dienstleistungen <br />
                    </span>
                  </v-tooltip>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="financing"
                  :items="Object.keys(levels.financing_levels)"
                  :menu-props="{ maxHeight: '400' }"
                  label="Finanzierung"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <v-btn
            rounded
            color="accent"
            class="ma-4"
            depressed
            @click="stepper = 1"
            >Zurück zu Schritt 1</v-btn
          >
          <v-btn
            rounded
            color="accent"
            class="ma-4"
            depressed
            v-on:click="
              showResults = true;
              $vuetify.goTo('#resultSection');
            "
            >Zum Ergebnis</v-btn
          >
        </v-stepper-content>
      </v-stepper>
    </v-container>
    <div id="resultSection">
      <v-container class="py-10" v-if="showResults">
        <v-container>
          <v-row class="justify-center">
            <v-col cols="12" class="text-center">
              <div
                class="text-uppercase display-2 pa-6 hidden-sm-and-down"
                style="color: #2E3440;"
              >
                Auswertung
              </div>
              <div
                class="text-uppercase display-1 pa-6 hidden-md-and-up"
                style="color: #2E3440;"
              >
                Auswertung
              </div>

              <v-divider
                style="border-color: #9d0c4a; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
              ></v-divider>

              <p class="title font-weight-light pt-6">
                Sehen Sie hier Ihre Ergebnisse und vergleichen Sie diese mit
                Organisationen, die ähnlich aufgestellt sind wie Ihre.
              </p>
            </v-col>
          </v-row>
        </v-container>

        <v-layout row>
          <v-col cols="12" md="6">
            <highcharts
              :options="chartOptionsGauge"
              ref="chartGauge"
            ></highcharts>
          </v-col>
          <v-col cols="12" md="6" class="align-self-center">
            <p>
              Welchen digitalen Reifegrad hat Ihre Organisation? Unser Reifegrad
              bestimmt den Fortschritt auf einer Skala von 0 bis 100. Basierend
              auf Ihren Angaben haben wir für Ihre Organisation einen Score von
              <b>{{ Math.round(this.calculatedScore * 100) }}</b>
              berechnet. Der durchschnittliche Wert von allen Organisationen in
              unserer Stichprobe ist <b>45,8</b>. Für Organisationen, die Ihrer
              Organisation ähnlich sind, haben wir einen durchschnittlichen Wert
              von
              <b>{{ Math.round(this.calculateBenchmarkMean * 100) }}</b>
              berechnet.
            </p>
            <p>
              Doch wie ist dieser Wert einzuschätzen? Wir haben berechnet, dass
              Ihr digitaler Reifegrad höher ist im Vergleich zu
              <b
                >{{
                  Math.round(
                    this.calculateBenchmarkDistributionPercentile * 100
                  )
                }}
                %</b
              >
              der Organisationen, die Ihrer ähnlich sind, und zu
              <b
                >{{
                  Math.round(
                    this.calculatePopulationDistributionPercentile * 100
                  )
                }}
                %</b
              >
              aller teilnehmenden Organisationen.
            </p>
          </v-col>
        </v-layout>
        <v-row>
          <v-col cols="12" lg="6">
            <highcharts
              :options="chartOptionsComp"
              ref="chartComp"
            ></highcharts>
            <v-flex xs3 offset-xs9 align-end>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    aria-hidden="true"
                    v-on="on"
                    :to="{ name: 'methodology' }"
                  >
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Stichprobe &amp; Methoden</span>
              </v-tooltip>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" aria-hidden="true">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="download('image/jpeg')">
                    <v-list-item-content>
                      <v-list-item-title>JPEG herunterladen</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="download('image/svg+xml')">
                    <v-list-item-content>
                      <v-list-item-title>SVG herunterladen</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
                    target="blank"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="pb-2" style="color: #7D9B38"
                        >Lizenzbedingungen</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </v-col>
          <v-col cols="12" lg="6">
            <highcharts
              constructor-type="mapChart"
              :options="chartOptionsMap"
              ref="chart"
            ></highcharts>
          </v-col>
        </v-row>
      </v-container>
      <!--
      <v-container class="py-10" v-if="showResults">
        <v-container>
          <v-row class="justify-center">
            <v-col cols="12" class="text-center">
              <div
                class="text-uppercase display-2 pa-6 hidden-sm-and-down"
                style="color: #2E3440;"
              >
                Nächste Schritte
              </div>
              <div
                class="text-uppercase display-1 pa-6 hidden-md-and-up"
                style="color: #2E3440;"
              >
                Nächste Schritte
              </div>

              <v-divider
                style="border-color: #9d0c4a; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
              ></v-divider>

              <p class="title font-weight-light pt-6">
                Basierend auf ihren Ergebnissen könnten folgende weiterführende
                Quellen interessant für sie sein.
              </p>
            </v-col>
          </v-row>
        </v-container>
        <v-row class="py-10">
          <v-col
            ><v-card class="mx-auto">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="headline">Link 1</v-list-item-title>
                  <v-list-item-subtitle>Institution</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
              ></v-img>

              <v-card-text>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Obcaecati numquam esse, autem nobis expedita minima officiis.
                Ipsa doloribus neque dolores eaque sequi similique id amet ex
                et, incidunt perferendis reprehenderit?
              </v-card-text>

              <v-card-actions>
                <v-btn text color="accent">
                  Jetzt lesen
                </v-btn>
              </v-card-actions>
            </v-card></v-col
          >
          <v-col>
            <v-card class="mx-auto">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="headline">Link 2</v-list-item-title>
                  <v-list-item-subtitle>Institution</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
              ></v-img>

              <v-card-text>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum
                assumenda nisi optio ipsam exercitationem quidem, sapiente
                nesciunt repudiandae nemo illo nam fuga illum autem eaque eum
                cumque voluptates consectetur quae!
              </v-card-text>

              <v-card-actions>
                <v-btn text color="accent">
                  Jetzt lesen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mx-auto">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="headline">Link 3</v-list-item-title>
                  <v-list-item-subtitle>Institution</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-img
                src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
                height="194"
              ></v-img>

              <v-card-text>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas,
                minus obcaecati voluptates cumque dolorum aperiam accusantium
                dolorem nobis quibusdam? Maxime, sequi fugiat. Sit ducimus
                accusamus distinctio dolor sequi, deleniti suscipit?
              </v-card-text>

              <v-card-actions>
                <v-btn text color="accent">
                  Jetzt lesen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      -->
    </div>
  </div>
</template>

<script>
import mapData from "@highcharts/map-collection/countries/de/de-all-all.geo.json";
// Helper Function to calculate percentiles from normal distribution
function normalcdf(X) {
  //HASTINGS.
  var T = 1 / (1 + 0.2316419 * Math.abs(X));
  var D = 0.3989423 * Math.exp((-X * X) / 2);
  var Prob =
    D *
    T *
    (0.3193815 +
      T * (-0.3565638 + T * (1.781478 + T * (-1.821256 + T * 1.330274))));
  if (X > 0) {
    Prob = 1 - Prob;
  }
  return Prob;
}

export default {
  name: "Benchmarking",
  data: () => ({
    item1: 2,
    item2: 2,
    item3: 2,
    item4: 2,
    item5: 2,
    showResults: false,
    state: "Bayern",
    sector: "Sport",
    age: "0 bis 1",
    budget: "Unter 10 Tsd.",
    financing: "NPO Klassisch",
    weights: [0.634, 0.749, 0.67, 0.789, 0.694],
    ticksLabels: ["Stimme gar nicht zu", "", "", "", "Stimme voll zu"],
    levels: {
      state_levels: {
        "Baden-Württemberg": 0,
        Bayern: -0.0003,
        Berlin: -0.0261,
        Brandenburg: -0.0218,
        Bremen: -0.0155,
        Hamburg: -0.0156,
        Hessen: 0.0072,
        "Mecklenburg-Vorpommern": -0.0395,
        Niedersachsen: -0.0309,
        "Nordrhein-Westfalen": -0.0032,
        "Rheinland-Pfalz": -0.0194,
        Saarland: -0.0645,
        Sachsen: -0.0413,
        "Sachsen-Anhalt": -0.1104,
        "Schleswig-Holstein": -0.0265,
        Thüringen: -0.0307
      },
      sector_levels: {
        Andere: 0,
        "Bevölkerungs-/Katastrophenschutz": 0.0553,
        "Bildung/Erziehung": -0.0173,
        "Bürger-/Verbraucherinteressen": -0.0337,
        "Freizeit/Geselligkeit": 0.0205,
        "Gemeinschaftliche Versorgungsaufgaben": 0.0287,
        Gesundheitswesen: -0.012,
        "Internationale Solidarität": 0.029,
        "Kirchen/religiöse Vereinigungen": -0.02,
        "Kultur/Medien": 0.0035,
        "Soziale Dienste": -0.038,
        Sport: 0.0443,
        "Umwelt-/Naturschutz": 0.0112,
        "Wirtschafts-/Berufsverbände": 0.063,
        "Wissenschaft/Forschung": 0.065
      },
      age_levels: {
        "0 bis 1": 0,
        "1 bis 15": -0.0137,
        "16 bis 31": -0.0497,
        "32 bis 64": -0.0503,
        ">65": -0.0586
      },
      budget_levels: {
        "Unter 10 Tsd.": 0,
        "10 Tsd. bis unter 50 Tsd.": -0.0156,
        "50 Tsd. bis unter 250 Tsd.": -0.0272,
        "250 Tsd. bis unter 1 Mio.": -0.034,
        "1 Mio. bis unter 10 Mio.": 0.02,
        "10 Mio. und mehr": 0.058,
        "Weiß nicht": 0.0272
      },
      financing_levels: {
        "NPO Klassisch": 0,
        "NPO Hybrid": 0.0086,
        "NPO Social Business": 0.0662
      },
      coefficients: {
        sigma: 0.2258,
        intercept: 0.5109
      }
    },
    literacyData: {
      Brandenburg: [
        ["de-bb-12051000", 0.4729 * 100],
        ["de-bb-12052000", 0.3446 * 100],
        ["de-bb-12053000", 0.2164 * 100],
        ["de-bb-12054000", 0.3709 * 100],
        ["de-bb-12060000", 0.4591 * 100],
        ["de-bb-12061000", 0.4688 * 100],
        ["de-bb-12063000", 0.4532 * 100],
        ["de-bb-12064000", 0.4411 * 100],
        ["de-bb-12065000", 0.5245 * 100],
        ["de-bb-12066000", 0.3744 * 100],
        ["de-bb-12067000", 0.4035 * 100],
        ["de-bb-12068000", 0.5471 * 100],
        ["de-bb-12069000", 0.5929 * 100],
        ["de-bb-12070000", 0.7352 * 100],
        ["de-bb-12071000", 0.4505 * 100],
        ["de-bb-12072000", 0.5467 * 100],
        ["de-bb-12073000", 0.3089 * 100]
      ],
      Berlin: [
        ["de-be-11000000", 0.4427 * 100],
        ["de-hh-02000000", 0.4592 * 100],
        ["de-hb-04012000", 0.2814 * 100]
      ],
      "Baden-Württemberg": [
        ["de-bw-08111000", 0.471 * 100],
        ["de-bw-08115000", 0.4765 * 100],
        ["de-bw-08116000", 0.449 * 100],
        ["de-bw-08117000", 0.4945 * 100],
        ["de-bw-08118000", 0.4414 * 100],
        ["de-bw-08119000", 0.5017 * 100],
        ["de-bw-08121000", 0.4823 * 100],
        ["de-bw-08125000", 0.3647 * 100],
        ["de-bw-08126000", 0.4527 * 100],
        ["de-bw-08127000", 0.4693 * 100],
        ["de-bw-08128000", 0.5059 * 100],
        ["de-bw-08135000", 0.2782 * 100],
        ["de-bw-08136000", 0.4046 * 100],
        ["de-bw-08211000", 0.4597 * 100],
        ["de-bw-08212000", 0.4747 * 100],
        ["de-bw-08215000", 0.5141 * 100],
        ["de-bw-08216000", 0.4019 * 100],
        ["de-bw-08221000", 0.4554 * 100],
        ["de-bw-08222000", 0.5103 * 100],
        ["de-bw-08225000", 0.4151 * 100],
        ["de-bw-08226000", 0.5244 * 100],
        ["de-bw-08231000", 0.5811 * 100],
        ["de-bw-08235000", 0.4902 * 100],
        ["de-bw-08236000", 0.333 * 100],
        ["de-bw-08237000", 0.4434 * 100],
        ["de-bw-08311000", 0.4524 * 100],
        ["de-bw-08315000", 0.4522 * 100],
        ["de-bw-08316000", 0.5092 * 100],
        ["de-bw-08317000", 0.4527 * 100],
        ["de-bw-08325000", 0.3758 * 100],
        ["de-bw-08326000", 0.387 * 100],
        ["de-bw-08327000", 0.5352 * 100],
        ["de-bw-08335000", 0.5268 * 100],
        ["de-bw-08336000", 0.5093 * 100],
        ["de-bw-08337000", 0.2487 * 100],
        ["de-bw-08415000", 0.3469 * 100],
        ["de-bw-08416000", 0.5099 * 100],
        ["de-bw-08417000", 0.6606 * 100],
        ["de-bw-08421000", 0.4558 * 100],
        ["de-bw-08425000", 0.4419 * 100],
        ["de-bw-08426000", 0.4636 * 100],
        ["de-bw-08435000", 0.499 * 100],
        ["de-bw-08436000", 0.3757 * 100],
        ["de-bw-08437000", 0.4779 * 100]
      ],
      Bayern: [
        ["de-by-09161000", 0.2741 * 100],
        ["de-by-09162000", 0.4896 * 100],
        ["de-by-09163000", 0.4329 * 100],
        ["de-by-09171000", 0.6576 * 100],
        ["de-by-09172000", 0.441 * 100],
        ["de-by-09173000", 0.5508 * 100],
        ["de-by-09174000", 0.4403 * 100],
        ["de-by-09175000", 0.3336 * 100],
        ["de-by-09176000", 0.5955 * 100],
        ["de-by-09177000", 0.395 * 100],
        ["de-by-09178000", 0.5565 * 100],
        ["de-by-09179000", 0.4081 * 100],
        ["de-by-09180000", 0.3478 * 100],
        ["de-by-09181000", 0.5283 * 100],
        ["de-by-09182000", 0.6345 * 100],
        ["de-by-09183000", 0.4109 * 100],
        ["de-by-09184000", 0.5153 * 100],
        ["de-by-09185000", 0.3983 * 100],
        ["de-by-09186000", 0.3636 * 100],
        ["de-by-09187000", 0.4815 * 100],
        ["de-by-09188000", 0.5642 * 100],
        ["de-by-09189000", 0.519 * 100],
        ["de-by-09190000", 0.4378 * 100],
        ["de-by-09261000", 0.4503 * 100],
        ["de-by-09262000", 0.3993 * 100],
        ["de-by-09263000", 0.5801 * 100],
        ["de-by-09271000", 0.5602 * 100],
        ["de-by-09272000", 0.753 * 100],
        ["de-by-09273000", 0.3764 * 100],
        ["de-by-09274000", 0.5918 * 100],
        ["de-by-09275000", 0.39 * 100],
        ["de-by-09276000", 0.3211 * 100],
        ["de-by-09277000", 0.3822 * 100],
        ["de-by-09278000", 0.5087 * 100],
        ["de-by-09279000", 0.6225 * 100],
        ["de-by-09361000", 0.3645 * 100],
        ["de-by-09362000", 0.4538 * 100],
        ["de-by-09371000", 0.6024 * 100],
        ["de-by-09372000", 0.4918 * 100],
        ["de-by-09373000", 0.6049 * 100],
        ["de-by-09374000", 0.4817 * 100],
        ["de-by-09375000", 0.4193 * 100],
        ["de-by-09376000", 0.4957 * 100],
        ["de-by-09461000", 0.4025 * 100],
        ["de-by-09462000", 0.4244 * 100],
        ["de-by-09463000", 0.1495 * 100],
        ["de-by-09464000", 0.3531 * 100],
        ["de-by-09471000", 0.301 * 100],
        ["de-by-09472000", 0.3396 * 100],
        ["de-by-09473000", 0.5688 * 100],
        ["de-by-09474000", 0.2603 * 100],
        ["de-by-09475000", 0.3676 * 100],
        ["de-by-09476000", 0.7046 * 100],
        ["de-by-09477000", 0.2948 * 100],
        ["de-by-09478000", 0.3941 * 100],
        ["de-by-09479000", 0.4431 * 100],
        ["de-by-09561000", 0.2156 * 100],
        ["de-by-09562000", 0.4962 * 100],
        ["de-by-09563000", 0.5613 * 100],
        ["de-by-09564000", 0.484 * 100],
        ["de-by-09571000", 0.443 * 100],
        ["de-by-09572000", 0.5694 * 100],
        ["de-by-09573000", 0.5874 * 100],
        ["de-by-09574000", 0.5666 * 100],
        ["de-by-09575000", 0.4162 * 100],
        ["de-by-09576000", 0.3904 * 100],
        ["de-by-09577000", 0.4478 * 100],
        ["de-by-09661000", 0.4881 * 100],
        ["de-by-09662000", 0.4858 * 100],
        ["de-by-09663000", 0.5016 * 100],
        ["de-by-09671000", 0.4143 * 100],
        ["de-by-09672000", 0.3519 * 100],
        ["de-by-09673000", 0.5908 * 100],
        ["de-by-09674000", 0.25 * 100],
        ["de-by-09676000", 0.3306 * 100],
        ["de-by-09677000", 0.467 * 100],
        ["de-by-09678000", 0.3622 * 100],
        ["de-by-09679000", 0.4899 * 100],
        ["de-by-09761000", 0.4097 * 100],
        ["de-by-09762000", 0.3325 * 100],
        ["de-by-09763000", 0.5621 * 100],
        ["de-by-09764000", 0.5033 * 100],
        ["de-by-09771000", 0.7399 * 100],
        ["de-by-09772000", 0.6 * 100],
        ["de-by-09773000", 0.4047 * 100],
        ["de-by-09774000", 0.4113 * 100],
        ["de-by-09775000", 0.4015 * 100],
        ["de-by-09776000", 0.3282 * 100],
        ["de-by-09777000", 0.3956 * 100],
        ["de-by-09778000", 0.4834 * 100],
        ["de-by-09779000", 0.4007 * 100],
        ["de-by-09780000", 0]
      ],
      Bremen: [
        ["de-hb-04012000", 0.2814 * 100],
        ["de-be-11000000", 0.4427 * 100],
        ["de-hh-02000000", 0.4592 * 100]
      ],
      Hessen: [
        ["de-he-06411000", 0.5612 * 100],
        ["de-he-06412000", 0.4827 * 100],
        ["de-he-06413000", 0.5347 * 100],
        ["de-he-06414000", 0.488 * 100],
        ["de-he-06431000", 0.5078 * 100],
        ["de-he-06432000", 0.5477 * 100],
        ["de-he-06433000", 0.4202 * 100],
        ["de-he-06434000", 0.4103 * 100],
        ["de-he-06435000", 0.4842 * 100],
        ["de-he-06436000", 0.4675 * 100],
        ["de-he-06437000", 0.5709 * 100],
        ["de-he-06438000", 0.504 * 100],
        ["de-he-06439000", 0.4368 * 100],
        ["de-he-06440000", 0.4556 * 100],
        ["de-he-06531000", 0.5129 * 100],
        ["de-he-06532000", 0.4248 * 100],
        ["de-he-06533000", 0.5904 * 100],
        ["de-he-06534000", 0.4049 * 100],
        ["de-he-06535000", 0.4743 * 100],
        ["de-he-06611000", 0.4677 * 100],
        ["de-he-06631000", 0.6097 * 100],
        ["de-he-06632000", 0.3726 * 100],
        ["de-he-06633000", 0.5767 * 100],
        ["de-he-06634000", 0.2771 * 100],
        ["de-he-06635000", 0.409 * 100],
        ["de-he-06636000", 0.348 * 100]
      ],
      Hamburg: [
        ["de-hh-02000000", 0.4592 * 100],
        ["de-be-11000000", 0.4427 * 100],
        ["de-hb-04012000", 0.2814 * 100]
      ],
      "Mecklenburg-Vorpommern": [
        ["de-mv-13003000", 0.4292 * 100],
        ["de-mv-13004000", 0.4324 * 100],
        ["de-mv-13071000", 0.4452 * 100],
        ["de-mv-13072000", 0.5215 * 100],
        ["de-mv-13073000", 0.414 * 100],
        ["de-mv-13074000", 0.6058 * 100],
        ["de-mv-13075000", 0.3827 * 100],
        ["de-mv-13076000", 0.3529 * 100]
      ],
      Niedersachsen: [
        ["de-ni-03101000", 0.3993 * 100],
        ["de-ni-03102000", 0.4535 * 100],
        ["de-ni-03103000", 0.4432 * 100],
        ["de-ni-03151000", 0.4591 * 100],
        ["de-ni-03153000", 0.3208 * 100],
        ["de-ni-03154000", 0.2761 * 100],
        ["de-ni-03155000", 0.4763 * 100],
        ["de-ni-03157000", 0.6142 * 100],
        ["de-ni-03158000", 0.6158 * 100],
        ["de-ni-03241000", 0.4059 * 100],
        ["de-ni-03251000", 0.5147 * 100],
        ["de-ni-03252000", 0.4285 * 100],
        ["de-ni-03254000", 0.4399 * 100],
        ["de-ni-03255000", 0.3052 * 100],
        ["de-ni-03256000", 0.4625 * 100],
        ["de-ni-03257000", 0.4743 * 100],
        ["de-ni-03351000", 0.4028 * 100],
        ["de-ni-03352000", 0.4555 * 100],
        ["de-ni-03353000", 0.4482 * 100],
        ["de-ni-03354000", 0.2861 * 100],
        ["de-ni-03355000", 0.3683 * 100],
        ["de-ni-03356000", 0.176 * 100],
        ["de-ni-03357000", 0.5568 * 100],
        ["de-ni-03358000", 0.4009 * 100],
        ["de-ni-03359000", 0.5609 * 100],
        ["de-ni-03360000", 0.5602 * 100],
        ["de-ni-03361000", 0.3829 * 100],
        ["de-ni-03401000", 0.4007 * 100],
        ["de-ni-03402000", 0.3025 * 100],
        ["de-ni-03403000", 0.4083 * 100],
        ["de-ni-03404000", 0.4879 * 100],
        ["de-ni-03405000", 0.459 * 100],
        ["de-ni-03451000", 0.5387 * 100],
        ["de-ni-03452000", 0.5314 * 100],
        ["de-ni-03453000", 0.6871 * 100],
        ["de-ni-03454000", 0.5198 * 100],
        ["de-ni-03455000", 0.5223 * 100],
        ["de-ni-03456000", 0.5094 * 100],
        ["de-ni-03457000", 0.3741 * 100],
        ["de-ni-03458000", 0.5252 * 100],
        ["de-ni-03459000", 0.5181 * 100],
        ["de-ni-03460000", 0.5142 * 100],
        ["de-ni-03461000", 0.3999 * 100],
        ["de-ni-04011000", 0.4624 * 100]
      ],
      "Nordrhein-Westfalen": [
        ["de-nw-05111000", 0.4594 * 100],
        ["de-nw-05112000", 0.4567 * 100],
        ["de-nw-05113000", 0.486 * 100],
        ["de-nw-05114000", 0.4652 * 100],
        ["de-nw-05116000", 0.4573 * 100],
        ["de-nw-05117000", 0.5882 * 100],
        ["de-nw-05119000", 0.4898 * 100],
        ["de-nw-05120000", 0.3643 * 100],
        ["de-nw-05122000", 0.4982 * 100],
        ["de-nw-05124000", 0.4939 * 100],
        ["de-nw-05154000", 0.4835 * 100],
        ["de-nw-05158000", 0.4853 * 100],
        ["de-nw-05162000", 0.5541 * 100],
        ["de-nw-05166000", 0.471 * 100],
        ["de-nw-05170000", 0.5602 * 100],
        ["de-nw-05314000", 0.4912 * 100],
        ["de-nw-05315000", 0.42 * 100],
        ["de-nw-05316000", 0.3525 * 100],
        ["de-nw-05334000", 0.5705 * 100],
        ["de-nw-05358000", 0.4908 * 100],
        ["de-nw-05362000", 0.4743 * 100],
        ["de-nw-05366000", 0.5195 * 100],
        ["de-nw-05370000", 0.4358 * 100],
        ["de-nw-05374000", 0.4893 * 100],
        ["de-nw-05378000", 0.5156 * 100],
        ["de-nw-05382000", 0.4468 * 100],
        ["de-nw-05512000", 0.5457 * 100],
        ["de-nw-05513000", 0.3284 * 100],
        ["de-nw-05515000", 0.4829 * 100],
        ["de-nw-05554000", 0.3768 * 100],
        ["de-nw-05558000", 0.504 * 100],
        ["de-nw-05562000", 0.4297 * 100],
        ["de-nw-05566000", 0.4078 * 100],
        ["de-nw-05570000", 0.3995 * 100],
        ["de-nw-05711000", 0.4494 * 100],
        ["de-nw-05754000", 0.4677 * 100],
        ["de-nw-05758000", 0.5295 * 100],
        ["de-nw-05762000", 0.5413 * 100],
        ["de-nw-05766000", 0.5048 * 100],
        ["de-nw-05770000", 0.3964 * 100],
        ["de-nw-05774000", 0.4743 * 100],
        ["de-nw-05911000", 0.5359 * 100],
        ["de-nw-05913000", 0.5427 * 100],
        ["de-nw-05914000", 0.6257 * 100],
        ["de-nw-05915000", 0.3473 * 100],
        ["de-nw-05916000", 0.2097 * 100],
        ["de-nw-05954000", 0.4381 * 100],
        ["de-nw-05958000", 0.5042 * 100],
        ["de-nw-05962000", 0.411 * 100],
        ["de-nw-05966000", 0.4835 * 100],
        ["de-nw-05970000", 0.5013 * 100],
        ["de-nw-05974000", 0.3375 * 100],
        ["de-nw-05978000", 0.3495 * 100]
      ],
      "Rheinland-Pfalz": [
        ["de-rp-07111000", 0.3694 * 100],
        ["de-rp-07131000", 0.4807 * 100],
        ["de-rp-07132000", 0.5369 * 100],
        ["de-rp-07133000", 0.447 * 100],
        ["de-rp-07134000", 0.5182 * 100],
        ["de-rp-07135000", 0.3701 * 100],
        ["de-rp-07137000", 0.324 * 100],
        ["de-rp-07138000", 0.5205 * 100],
        ["de-rp-07140000", 0.4571 * 100],
        ["de-rp-07141000", 0.588 * 100],
        ["de-rp-07143000", 0.4829 * 100],
        ["de-rp-07211000", 0.3773 * 100],
        ["de-rp-07231000", 0.3192 * 100],
        ["de-rp-07232000", 0.3032 * 100],
        ["de-rp-07235000", 0.3391 * 100],
        ["de-rp-07311000", 0.4491 * 100],
        ["de-rp-07312000", 0.4676 * 100],
        ["de-rp-07313000", 0.3579 * 100],
        ["de-rp-07314000", 0.4423 * 100],
        ["de-rp-07315000", 0.4593 * 100],
        ["de-rp-07316000", 0.4243 * 100],
        ["de-rp-07317000", 0.5292 * 100],
        ["de-rp-07318000", 0.4841 * 100],
        ["de-rp-07319000", 0.2584 * 100],
        ["de-rp-07320000", 0.56 * 100],
        ["de-rp-07331000", 0.4759 * 100],
        ["de-rp-07332000", 0.4528 * 100],
        ["de-rp-07333000", 0.2759 * 100],
        ["de-rp-07334000", 0.6508 * 100],
        ["de-rp-07335000", 0.4636 * 100],
        ["de-rp-07336000", 0.7611 * 100],
        ["de-rp-07337000", 0.6307 * 100],
        ["de-rp-07338000", 0.5261 * 100],
        ["de-rp-07339000", 0.3713 * 100],
        ["de-rp-07340000", 0.5482 * 100]
      ],
      "Schleswig-Holstein": [
        ["de-sh-01001000", 0.3095 * 100],
        ["de-sh-01002000", 0.3791 * 100],
        ["de-sh-01003000", 0.4913 * 100],
        ["de-sh-01004000", 0.3361 * 100],
        ["de-sh-01051000", 0.5688 * 100],
        ["de-sh-01053000", 0.4398 * 100],
        ["de-sh-01054000", 0.341 * 100],
        ["de-sh-01055000", 0.545 * 100],
        ["de-sh-01056000", 0.4933 * 100],
        ["de-sh-01057000", 0.5267 * 100],
        ["de-sh-01058000", 0.4713 * 100],
        ["de-sh-01059000", 0.4217 * 100],
        ["de-sh-01060000", 0.4587 * 100],
        ["de-sh-01061000", 0.4845 * 100],
        ["de-sh-01062000", 0.425 * 100]
      ],
      Saarland: [
        ["de-sl-10041000", 0.3888 * 100],
        ["de-sl-10042000", 0.5782 * 100],
        ["de-sl-10043000", 0.4122 * 100],
        ["de-sl-10044000", 0.3864 * 100],
        ["de-sl-10045000", 0.491 * 100],
        ["de-sl-10046000", 0.3928 * 100]
      ],
      Sachsen: [
        ["de-sn-14511000", 0.4017 * 100],
        ["de-sn-14521000", 0.4689 * 100],
        ["de-sn-14522000", 0.393 * 100],
        ["de-sn-14523000", 0.4514 * 100],
        ["de-sn-14524000", 0.36 * 100],
        ["de-sn-14612000", 0.4373 * 100],
        ["de-sn-14625000", 0.5337 * 100],
        ["de-sn-14626000", 0.4868 * 100],
        ["de-sn-14627000", 0.2917 * 100],
        ["de-sn-14628000", 0.3171 * 100],
        ["de-sn-14713000", 0.396 * 100],
        ["de-sn-14729000", 0.4899 * 100]
      ],
      "Sachsen-Anhalt": [
        ["de-st-14730000", 0.4787 * 100],
        ["de-st-15001000", 0.4463 * 100],
        ["de-st-15002000", 0.3406 * 100],
        ["de-st-15003000", 0.3141 * 100],
        ["de-st-15081000", 0.5978 * 100],
        ["de-st-15082000", 0.3329 * 100],
        ["de-st-15083000", 0.3438 * 100],
        ["de-st-15084000", 0.3478 * 100],
        ["de-st-15085000", 0.3506 * 100],
        ["de-st-15086000", 0.1984 * 100],
        ["de-st-15087000", 0.3708 * 100],
        ["de-st-15088000", 0.5357 * 100],
        ["de-st-15089000", 0.2203 * 100],
        ["de-st-15090000", 0.4137 * 100],
        ["de-st-15091000", 0.3997 * 100]
      ],
      Thüringen: [
        ["de-th-16051000", 0.4827 * 100],
        ["de-th-16052000", 0.4147 * 100],
        ["de-th-16053000", 0.4006 * 100],
        ["de-th-16054000", 0.5993 * 100],
        ["de-th-16055000", 0.4039 * 100],
        ["de-th-16056000", 0.436 * 100],
        ["de-th-16061000", 0.4562 * 100],
        ["de-th-16062000", 0.4005 * 100],
        ["de-th-16063000", 0.375 * 100],
        ["de-th-16064000", 0.9526 * 100],
        ["de-th-16065000", 0.4317 * 100],
        ["de-th-16066000", 0.3748 * 100],
        ["de-th-16067000", 0.4549 * 100],
        ["de-th-16068000", 0.5069 * 100],
        ["de-th-16069000", 0.5056 * 100],
        ["de-th-16070000", 0.4781 * 100],
        ["de-th-16071000", 0.4073 * 100],
        ["de-th-16072000", 0.4049 * 100],
        ["de-th-16073000", 0.4655 * 100],
        ["de-th-16074000", 0.3479 * 100],
        ["de-th-16075000", 0.1606 * 100],
        ["de-th-16076000", 0.394 * 100],
        ["de-th-16077000", 0.3118 * 100]
      ]
    },
    // data for stepper
    stepper: 1
  }),
  computed: {
    // calculate index score based on the inputs of the 5 items and their weighting
    calculatedScore: function() {
      var score =
        (this.item1 + 1) * this.weights[0] +
        (this.item2 + 1) * this.weights[1] +
        (this.item3 + 1) * this.weights[2] +
        (this.item4 + 1) * this.weights[3] +
        (this.item5 + 1) * this.weights[4];

      var score_max =
        5 * this.weights[0] +
        5 * this.weights[1] +
        5 * this.weights[2] +
        5 * this.weights[3] +
        5 * this.weights[4];
      var score_min =
        1 * this.weights[0] +
        1 * this.weights[1] +
        1 * this.weights[2] +
        1 * this.weights[3] +
        1 * this.weights[4];

      var score_normalized = (score - score_min) / (score_max - score_min);
      return Math.round(score_normalized * 1000) / 1000;
    },

    // calculate the benchmark mean as a function of the filter inputs and the Bayesian Linear Regression Means
    calculateBenchmarkMean: function() {
      var y_hat =
        this.levels.coefficients["intercept"] +
        this.levels.state_levels[this.state] +
        this.levels.sector_levels[this.sector] +
        this.levels.age_levels[this.age] +
        this.levels.budget_levels[this.budget] +
        this.levels.financing_levels[this.financing];
      return Math.round(y_hat * 1000) / 1000;
    },

    // Calculate the Percentile value of the Index Score in the Posterior Distribution
    calculateBenchmarkDistributionPercentile: function() {
      var dist = normalcdf(
        (this.calculatedScore - this.calculateBenchmarkMean) /
          this.levels.coefficients["sigma"]
      );
      if (dist <= 0.03) {
        dist = 0.01;
      }
      if (dist >= 0.97) {
        dist = 1;
      }
      var value = Math.ceil(dist * 1000) / 1000;
      return value;
    },

    // Calculate the Percentile Value of the Index Score in the Population Distriburion
    calculatePopulationDistributionPercentile: function() {
      var dist100 = normalcdf((this.calculatedScore - 0.458) / 0.2258);
      if (dist100 <= 0.03) {
        dist100 = 0.01;
      }
      if (dist100 >= 0.97) {
        dist100 = 1;
      }
      var value = Math.ceil(dist100 * 1000) / 1000;
      return value;
    },

    // Calculate the Probabilities for each percentile
    calculateBenchmarkDistribution100: function() {
      var percentiles = [0];
      var prob_per_percentile = [0];
      var i = 0;
      while (i <= 100) {
        i += 1;
        var perc = normalcdf(
          (i / 100 - this.calculateBenchmarkMean) /
            this.levels.coefficients["sigma"]
        );
        //perc = Math.round(100000 * perc) / 100000;
        percentiles.push(perc);

        var prob = percentiles[i] - percentiles[i - 1];
        prob = Math.round(10000 * prob) / 10000;

        prob_per_percentile.push(prob);
      }
      return prob_per_percentile;
    },

    // Draw a sample from the theoretical posterior distribution
    drawPosteriorSample: function() {
      var prob_array = this.calculateBenchmarkDistribution100;

      // Create a "population" array. JS only has the Math.random function built in, which allows draws from a uniform distribution; therefore I have to translate the prob distribtion into a uniform distribution where each value appears n times conditional on its probability
      var population_array = [];
      var i = 0;
      while (i < prob_array.length) {
        i += 1;
        var n_to_push = Math.floor(prob_array[i] * 10000) / 10;
        for (var j = 0; j < n_to_push; j++) population_array.push(i);
      }

      // Make a random draw 1000 times from the populations distribution
      var sample = [];
      for (var n = 0; n < 1000; n++)
        sample.push(
          population_array[Math.floor(Math.random() * population_array.length)]
        );
      return sample;
    },

    chartOptionsComp() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Ihr digitaler Reifegrad im Vergleich"
        },
        xAxis: {
          categories: [
            "Im Vergleich zu ähnlichen Organisationen",
            "Im Vergleich zur Population"
          ]
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Verteilung"
          }
        },
        tooltip: {
          valueSuffix: "%"
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        colors: ["#ad4594", "#2E3440", "#0391af"],
        series: [
          {
            name: "Organisationen mit besserem Wert",
            data: [
              Math.ceil(
                100 - this.calculateBenchmarkDistributionPercentile * 100
              ),
              Math.ceil(
                100 - this.calculatePopulationDistributionPercentile * 100
              )
            ]
          },
          {
            name: "Ihr Perzentil",
            data: [1, 1]
          },
          {
            name: "Organisationen mit schlechterem Wert",
            data: [
              Math.ceil(this.calculateBenchmarkDistributionPercentile * 100) -
                1,
              Math.ceil(this.calculatePopulationDistributionPercentile * 100) -
                1
            ]
          }
        ],

        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Überblick",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              // Make the labels less space demanding on mobile
              chartOptions: {
                xAxis: {
                  labels: {
                    style: {
                      font:
                        "10px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                    }
                  }
                },
                yAxis: {
                  labels: {
                    style: {
                      font:
                        "10px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                    }
                  }
                }
              }
            }
          ]
        }
      };
    },

    chartOptionsGauge() {
      return {
        chart: {
          type: "solidgauge",
          backgroundColor: null,
          height: "60%"
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ""
        },
        tooltip: {
          enabled: false
        },
        pane: {
          center: ["50%", "50%"],
          startAngle: 0,
          endAngle: 360,
          background: {
            backgroundColor: "#eceff4",
            shape: "arc"
          }
        },
        yAxis: {
          stops: [
            [0.33, "#9d0c4a"], // red
            [0.4, "#0391af"], // yellow
            [0.6, "#ad4594"] // green
          ],
          min: 0,
          max: 100,
          labels: {
            enabled: false
          },
          lineWidth: 0,
          minorTickInterval: null,
          tickPixelInterval: 400,
          tickWidth: 0
        },
        plotOptions: {
          solidgauge: {
            innerRadius: "75%",
            borderWidth: "100px"
          }
        },
        series: [
          {
            name: "Score",
            data: [Math.round(this.calculatedScore * 1000) / 10],
            dataLabels: {
              format:
                `<div style="text-align:center"><span style="font-size:24px;color: black">{y}/100</span><div>` +
                "</div><div/>",
              borderColor: null,
              y: -25,
              align: "center",
              useHTML: true
            }
          }
        ]
      };
    },

    chartOptionsMap() {
      return {
        chart: {
          map: mapData,
          zoomType: "xy"
        },
        title: {
          text: "Durschnittlicher Reifegrad in Ihrer Region"
        },
        subtitle: {
          text: "Wählen Sie ein Gebiet aus, um zu zoomen",
          style: {
            color: "#2E3440",
            font:
              "12px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif",
            fontWeight: "light"
          }
        },
        tooltip: {
          formatter: function() {
            return (
              "Kreis:  " +
              this.point.name +
              "<br>" +
              "Durchschnittlicher Digitaler Reifegrad: " +
              Math.round(this.point.value * 100) / 100
            );
          }
        },
        mapNavigation: {
          enabled: false,
          //enableTouchZoom: true,
          buttonOptions: {
            style: {
              color: "white"
            },
            verticalAlign: "top",
            align: "right",
            theme: {
              fill: "#f06914",
              "stroke-width": 1,
              stroke: "white",
              r: 2,
              states: {
                hover: {
                  fill: "#f4965a"
                },
                select: {
                  stroke: "#039",
                  fill: "#f06914"
                }
              }
            }
          }
        },

        colorAxis: {
          tickPixelInterval: 100,
          stops: [
            [0, "#40c1dc"],
            [0.35, "#0391af"],
            [0.6, "#005a85"]
          ]
        },

        exporting: {
          enabled: false
        },
        series: [
          {
            nullInteraction: false,
            data: this.literacyData[this.state],
            keys: ["hc-key", "value"],
            joinBy: "hc-key",
            name: "Durchschnittlicher Wert",
            states: {
              hover: {
                color: "#a4edba"
              }
            },
            dataLabels: {
              enabled: true,
              format: "{point.properties.postal}"
            }
          }
        ]
      };
    }
  },
  methods: {
    downloadJPEGComp() {
      this.$refs.chartComp.chart.exportChart({
        type: "image/jpeg",
        sourceHeight: "40%"
      });
    },
    downloadSVGComp() {
      this.$refs.chartComp.chart.exportChart({
        type: "image/svg+xml",
        sourceHeight: "40%"
      });
    },
    downloadPDFComp() {
      this.$refs.chartComp.chart.exportChart({
        type: "application/pdf",
        sourceHeight: "40%"
      });
    },
    downloadCSVComp() {
      this.$refs.chartComp.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.snow {
  background-color: #f5f5f5;
}

.v-input {
  font-size: 12px !important;
}
</style>
